var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 11.6665V19.6665",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3334 11.6665V19.6665",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 6.3335H22.3333",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.66663 6.3335H11.6666H19.6666V21.0002C19.6666 23.2094 17.8758 25.0002 15.6666 25.0002H7.66663C5.45749 25.0002 3.66663 23.2094 3.66663 21.0002V6.3335Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.66663 3.66667C7.66663 2.19391 8.86053 1 10.3333 1H13C14.4728 1 15.6666 2.19391 15.6666 3.66667V6.33333H7.66663V3.66667Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDelete);
export default __webpack_public_path__ + "static/media/greenDelete.449a259e7b29dc9ce15b935f08bd303b.svg";
export { ForwardRef as ReactComponent };